import React from 'react'

function Interest() {
  return (
    <div>This is Interest</div>
  )
}

export default Interest
